import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export function initPanels() {
	const panels = gsap.utils.toArray('.presentation__section');
	if (!panels.length) return;

	const sectionsWrapper = document.querySelector('.presentation__sections');
	if (!sectionsWrapper) return;

	const navFilterItems = document.querySelector('.filters__items');
	const navLis = navFilterItems ? navFilterItems.querySelectorAll('li') : [];

	let panelsTimeline = null;

	/**
	 * Construit la timeline avec les panneaux visibles
	 */
	function buildTimeline(visiblePanels) {
		// Nettoyage propre : uniquement la timeline précédente
		if (panelsTimeline) {
			if (panelsTimeline.scrollTrigger) {
				panelsTimeline.scrollTrigger.kill();
			}
			panelsTimeline.kill();
			panelsTimeline = null;
		}

		// Nouvelle timeline avec ScrollTrigger
		panelsTimeline = gsap.timeline({
			scrollTrigger: {
				trigger: sectionsWrapper,
				start: 'bottom bottom', // Se déclenche lorsque le bas de l'élément touche le bas de l'écran
				end: () => '+=' + Math.max(0, (visiblePanels.length - 1) * window.innerHeight),
				scrub: true,
				pin: true,
			}
		});

		// Animation d’entrée du premier panel
		const firstTexts = visiblePanels[0].querySelectorAll('h2, p');
		if (firstTexts.length) {
			gsap.fromTo(
				firstTexts,
				{ opacity: 0, y: 20 },
				{ opacity: 1, y: 0, stagger: 0.2, duration: 0.6, ease: 'power2.out' }
			);
		}

		// Transitions entre panels
		visiblePanels.forEach((panel, i) => {
			if (i < visiblePanels.length - 1) {
				panelsTimeline.to(panel, { opacity: 0, scale: 0.9, ease: 'none' }, i);

				panelsTimeline.fromTo(
					visiblePanels[i + 1],
					{ autoAlpha: 0, scale: 0.5, yPercent: 100 },
					{ autoAlpha: 1, scale: 1, yPercent: 0, ease: 'power2.out' },
					i
				);

				const nextTexts = visiblePanels[i + 1].querySelectorAll('h2, p');
				if (nextTexts.length) {
					panelsTimeline.fromTo(
						nextTexts,
						{ opacity: 0, y: 20 },
						{ opacity: 1, y: 0, stagger: 0.2, duration: 0.6, ease: 'power2.out' },
						i + 0.1
					);
				}
			}
		});

		// Refresh pour recalculer les positions
		// ScrollTrigger.refresh();
	}

	/**
	 * Filtrage des panneaux
	 */
	function filterPanels(category) {
		const visiblePanels = [];

		panels.forEach(panel => {
			const match = category === 'all' || panel.dataset.category === category;

			if (match) {
				panel.style.display = 'block';
				panel.setAttribute('aria-hidden', 'false');
				visiblePanels.push(panel);
			} else {
				panel.style.display = 'none';
				panel.setAttribute('aria-hidden', 'true');
			}
		});

		// Si aucun panneau visible, fallback sur "all"
		const finalVisiblePanels = visiblePanels.length ? visiblePanels : panels;

		// Construire la timeline
		buildTimeline(finalVisiblePanels);
	}

	/**
	 * Initialisation du filtre par défaut
	 */
	let defaultCategory = 'all';
	if (navLis.length > 0) {
		const firstLi = navLis[0];
		defaultCategory = firstLi.dataset.spfilter || firstLi.textContent.trim() || 'all';
	}

	// 🔎 Vérifie si un paramètre "filter" est présent dans l’URL
	const urlParams = new URLSearchParams(window.location.search);
	const urlFilter = urlParams.get('filter');
	if (urlFilter) {
		defaultCategory = urlFilter;
	}

	// Activer un état initial fonctionnel
	filterPanels(defaultCategory);

	// Met à jour l’état actif dans la navigation
	if (navLis.length > 0) {
		navLis.forEach(li => {
			const cat = li.dataset.spfilter || li.textContent.trim();
			if (cat === defaultCategory) {
				li.classList.add('active');
			} else {
				li.classList.remove('active');
			}
		});
	}

	/**
	 * Gestion des clics sur les filtres
	 */
	if (navFilterItems) {
		navFilterItems.addEventListener('click', e => {
			const li = e.target.closest('li');
			if (!li) return;

			const cat = li.dataset.spfilter || li.textContent.trim() || 'all';

			filterPanels(cat);

			// 👉 Attendre que ScrollTrigger ait recalculé les positions
			requestAnimationFrame(() => {
				// ScrollTrigger.refresh();

				// 👉 Scroll vers le début de la section animée
				gsap.to(window, {
					scrollTo: { y: '#presentation', autoKill: false },
					duration: 0
				});
			});

			// Mettre à jour l’état actif
			navLis.forEach(el => el.classList.remove('active'));
			li.classList.add('active');

		});
	}
}